import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import CryptoJS from 'crypto-js';
import config from '../config/config';
import { json, useNavigate } from "react-router-dom";




// Function to load script and append in DOM tree.
const loadScript = src => new Promise((resolve) => {
  const script = document.createElement('script');
  script.src = src;
  script.onload = () => {
    console.log('Razorpay loaded successfully');
    resolve(true);
  };
  script.onerror = () => {
    console.log('Error in loading Razorpay');
    resolve(false);
  };
  document.body.appendChild(script);
});



const RenderRazorpay = ({
  amount,
  currency,
  orderId,
  keyId,
  keySecret,
  

}) => {

  

  const { API_BASE_URL } = config;

  const paymentId = useRef(null);
  const paymentMethod = useRef(null);
  const navigate = useNavigate();

   const loginUser =JSON.parse(localStorage.getItem('user'));
   const userId = loginUser.uuid
  //  console.log("userid",userId)
  const courseItem = JSON.parse(localStorage.getItem('cart'));
 

  console.log("courseItem",courseItem);
   useEffect(() => {
    console.log('Initializing Razorpay');
    displayRazorpay(options);
  }, []);




  const displayRazorpay = async (options) => {
    const res = await loadScript(
      'https://checkout.razorpay.com/v1/checkout.js',
    );

    if (!res) {
      console.log('Razorpay SDK failed to load. Are you online?');
      return;
    }

    const rzp1 = new window.Razorpay(options);

    rzp1.on('payment.submit', (response) => {
      paymentMethod.current = response.method;
      console.log("paymentMethod response",response)

      console.log(" paymentMethod.current", paymentId.current)

    });


    rzp1.on('payment.failed', (response) => {
      paymentId.current = response.error.metadata.payment_id;
    });


    rzp1.open();
  };

  // Informing server about payment
  const handlePayment = async (status, orderDetails = {}) => {

    sessionStorage.setItem('paymentId',paymentId.current)


    const newOrderDetails = {
      Id:userId,
      orderId: orderDetails.orderId,
      PaymentId: paymentId.current,
      Signature: orderDetails.signature,
      PaymentStatus: status,
      Currency: "INR",
      Amount: amount,
      PaymentMode: paymentMethod.current,
      IsActive:true,
      PaymentDate:"2024-06-26T00:00:00Z"
    };



    try {
      const res = await fetch(`${API_BASE_URL}/Payment/CapturePayment`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newOrderDetails,)
      });
      if(res.ok){
        const data = await res.json();
            console.log("CapturePayment ",data);
            const courseAmountId = data.courseAmount.srNo;
            console.log("courseAmountId ",courseAmountId)
       
        // navigate('/transactionslip')
        const assignCourses = courseItem.map(obj => ({ ...obj,  Paymentid: courseAmountId,IsActive:true,userId:userId, Courseid:obj.id, }));
        console.log("assignCourses",assignCourses)  
        try{
          const response = fetch(`${API_BASE_URL}/Courses/CreateAssignedCourses`,{
            method:'POST',
            headers :{'Content-Type':'application/json'},
            body : JSON.stringify({AssignedCourses : assignCourses})
          })
          if(response.ok){
            const data = await response.json();
            console.log("data ",data)
           

      
          }
        }
        catch(error){
          console.error("API Error",error.Error);
        }

      }

      else if (!res.ok) {
        throw new Error('Failed to save payment response');
      }

      
    } catch (error) {
      console.error('Error:', error);
    }

  };
 




  const options = {
    key: keyId,
    amount,
    currency,
    

    order_id: orderId,
    // This handler menthod is always executed in case of succeeded payment
    handler: (response) => {
      paymentId.current = response.razorpay_payment_id;
      

      const message = `${response.razorpay_order_id}|${response.razorpay_payment_id}`;
      const hmac = CryptoJS.HmacSHA256(message, keySecret).toString(CryptoJS.enc.Hex);
      console.log("HMAC: ", hmac);
      console.log("Razorpay Signature: ", response.razorpay_signature);

      const succeeded = hmac === response.razorpay_signature;


      // If successfully authorized. Then we can consider the payment as successful.
      if (succeeded) {
        handlePayment('succeeded', {
          orderId,
          paymentId,
          signature: response.razorpay_signature,
        });
        const rzpModal = document.querySelector('.razorpay-container')
        if (rzpModal){
          rzpModal.remove();

        } 

      } 
      else {
        handlePayment('failed', {
          orderId,
          paymentId: response.razorpay_payment_id,
        });
      }
    },
    modal: {
      confirm_close: true,
      
      ondismiss: async (reason) => {
        const {
          reason: paymentReason, field, step, code,
        } = reason && reason.error ? reason.error : {};
        console.log("reason",reason)
        // Reason 1 - when payment is cancelled. It can happend when we click cross icon or cancel any payment explicitly. 
        if (reason === undefined) {
          console.log('cancelled');
          // handlePayment('Cancelled',{
          //   orderId,
         
          // });
        }
        // Reason 2 - When modal is auto closed because of time out
        else if (reason === 'timeout') {
          console.log('timedout');
          handlePayment('timedout',{
            orderId,
           
          });
        }
        // Reason 3 - When payment gets failed.
        else {
          console.log('failed');
          handlePayment('failed', {
            paymentReason, field, step, code,
          });
        }
      },
    },

    retry: {
      enabled: false,
    },
    timeout: 900,
    theme: {
      color: '', // Custom color for your checkout modal.
    },
  };
  

 
};

RenderRazorpay.propTypes = {
  orderId: PropTypes.string.isRequired,
  keyId: PropTypes.string.isRequired,
  keySecret: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
};



export default RenderRazorpay;
